<template>
    <div>
        <b-form>
            <b-form-group :label="$t('document_validity.valid_begin_date')">
                <b-form-datepicker v-model="form.validityBegins" class="mb-2" :disabled="disabled"
                    :placeholder="this.$t('datepicker.labelNoDateSelected')"
                    :locale="this.$t('datepicker.locale')"></b-form-datepicker>
            </b-form-group>

            <b-form-group :label="$t('document_validity.valid_end_date')">
                <b-form-datepicker v-model="form.validityEnds" :min="this.form.validityBegins" :max="max" class="mb-2"
                    :disabled="disabled" :placeholder="this.$t('datepicker.labelNoDateSelected')"
                    :locale="this.$t('datepicker.locale')"></b-form-datepicker>
            </b-form-group>
        </b-form>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'DocumentValidityEditor',
    props: {
        docOptJsonMsg: Object
    },
    data() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const minDate = new Date(today);
        const maxDate = new Date(today);
        maxDate.setMonth(maxDate.getMonth() + 120);

        let validityBegins = minDate;
        let validityEnds = null;

        if (this.docOptJsonMsg && this.docOptJsonMsg.validity_begins) {
            validityBegins = new Date(this.docOptJsonMsg.validity_begins);
        }
        if (this.docOptJsonMsg && this.docOptJsonMsg.validity_ends) {
            validityEnds = new Date(this.docOptJsonMsg.validity_ends);
        }

        return {
            passedFormData: this.docOptJsonMsg,
            min: minDate,
            max: maxDate,
            form: {
                validityBegins: validityBegins,
                validityEnds: validityEnds
            },
            disabled: false,
            baseId: null,
        };
    },
    watch: {
        docOptJsonMsg: {
            handler(newVal) {
                if (newVal && newVal.validity_begins) {
                    this.form.validityBegins = new Date(newVal.validity_begins);
                } else {
                    this.form.validityBegins = this.min;
                }
                if (newVal && newVal.validity_ends) {
                    this.form.validityEnds = new Date(newVal.validity_ends);
                } else {
                    this.form.validityEnds = null;
                }
            },
            immediate: true
        }
    },
    methods: {
        collectValidityData() {
            return {
                validityBegins: this.form.validityBegins ? moment(this.form.validityBegins).format('YYYY-MM-DD') : null,
                validityEnds: this.form.validityEnds ? moment(this.form.validityEnds).format('YYYY-MM-DD') : null
            };
        }
    }
}
</script>
